import { Stack, Typography, ProgressBar } from "@financeable-com-au/financeable-ui";
import { getProgressStatus } from "@/utils/getProgressStatus";

export const ApplicationProgressBar = ({ value }: { value: number }) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <ProgressBar value={value} status={getProgressStatus(value)} size="lg" />
      <Typography level="body-md">{value}%</Typography>
    </Stack>
  );
};
